import React, { Component } from 'react';
import styled from '@emotion/styled';

const BaseStyles = styled.div`
  .activated > div {
    background: #57a8e6;
  }

  .activated span:nth-of-type(1) svg {
    display: none;
  }

  .activated span:nth-of-type(2) svg {
    display: block;
  }

  .activated svg path {
    fill: #ffffff;
  }

  #SupportWidget {
    position: fixed;
    top: 70px;
    right: 0;
    height: calc(100vh - 70px);
    width: 400px;
    background: #fff;
    z-index: 25;
    box-shadow: -3px 0 3px 0 rgba(0, 0, 0, 0.07);
    -webkit-transform: translateX(120%);
    -ms-transform: translateX(120%);
    -moz-transform: translateX(120%);
    transform: translateX(120%);
    -webkit-transition: transform 500ms;
    -ms-transition: transform 500ms;
    -moz-transition: transform 500ms;
    transition: transform 500ms;
  }

  @media screen and (max-width: 540px) {
    #SupportWidget {
      width: 100%;
    }
  }

  #SupportWidget.support-visible {
    -webkit-transform: translateX(0%);
    -ms-transform: translateX(0%);
    -moz-transform: translateX(0%);
    transform: translateX(0%);
  }

  #SupportWidget a {
    font-weight: 600;
    color: #007db8;
    text-decoration: none;
    cursor: pointer;
  }

  #SupportWidget a:after {
    content: '';
    display: block;
    width: 100%;
    height: 3px;
    background: #57a8e6;
    opacity: 0;
    transform: translateY(0);
    transition: all 175ms;
  }

  #SupportWidget a:hover:after {
    opacity: 1;
    transform: translateY(3px);
  }

  #SupportWidget .controls {
    position: relative;
    padding: 30px 20px 70px 20px;
    background: #fff;
    color: #566072;
    border-bottom: 1px solid #e4e4e4;
    border-top: 6px solid #4694ce;
  }

  #SupportWidget .controls .inner {
    position: relative;
    z-index: 2;
  }

  #SupportWidget .controls h1 {
    margin: 0 0 10px 0;
    padding: 0;
    text-align: center;
    font-size: 24px;
    font-weight: 400;
    margin-bottom: 20px;
    color: #566072;
  }

  #SupportWidget .controls .query-field {
    position: relative;
  }

  #SupportWidget .controls .query-field input[type='text'] {
    width: calc(100%);
    padding-top: 10px;
    padding-bottom: 10px;
    padding-left: 40px;
    padding-right: 40px;
    font-size: 16px;
    color: #566072;
    border: 2px solid #bdcad2;
  }

  #SupportWidget .controls .query-field svg.search-ico {
    position: absolute;
    left: 10px;
    top: 12px;
  }

  #SupportWidget .controls .query-field svg.search-ico path {
    fill: #aaa;
  }

  #SupportWidget .controls .query-field .reset-support-query {
    position: absolute;
    right: 16px;
    top: 10px;
    width: 12px;
    height: 16px;
    cursor: pointer;
  }

  #SupportWidget .controls .query-field .reset-support-query svg {
    width: 12px;
    height: 12px;
  }

  #SupportWidget .controls .query-field .reset-support-query svg path {
    fill: #aaaaaa;
  }

  #SupportWidget .controls .query-field .reset-support-query:hover svg path {
    fill: #007db8;
  }

  #SupportWidget .controls .support-sites {
    position: absolute;
    padding: 0 20px;
    bottom: 20px;
    left: 0;
    width: calc(100%);
    z-index: 2;
  }

  #SupportWidget .controls .support-sites:after {
    content: '';
    display: block;
    clear: both;
  }

  #SupportWidget .controls .support-sites a {
    font-size: 15px;
    float: left;
  }

  #SupportWidget .controls .support-sites a + a {
    float: right;
  }

  #SupportWidget .support-search-results {
    padding-top: 5px;
    height: calc(100% - 198px);
    overflow-y: auto;
  }

  #SupportWidget .support-search-results p {
    padding: 50px 20px 20px 20px;
    font-size: 18px;
    color: #aaa;
    text-align: center;
  }

  #SupportWidget .support-search-results ul {
    list-style: none;
    padding: 0 20px;
    margin: 0;
  }

  #SupportWidget .support-search-results ul li {
    display: block;
    padding: 15px 0 10px 0;
    border-bottom: 1px solid #e4e4e4;
  }

  #SupportWidget .support-search-results ul li:first-of-type {
    padding-top: 10px;
  }

  #SupportWidget .support-search-results ul li a {
    display: inline-block;
    position: relative;
    font-size: 15px;
  }

  #SupportWidget .loading-bar {
    position: absolute;
    left: 0;
    width: 100%;
    height: 5px;
    opacity: 0;
    transition: opacity 300ms;
    position: absolute;
    bottom: 0;
    left: 0;
    background-image: linear-gradient(to right, #006aa1, #57a8e6, #9ad3fd, #57a8e6, #006aa1);
  }

  #SupportWidget .loading-bar:after {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-image: linear-gradient(to right, #9ad3fd, #57a8e6, #006aa1, #57a8e6, #9ad3fd);
  }

  #SupportWidget .loading-bar.showing {
    opacity: 1;
  }

  #SupportWidget .loading-bar.showing:after {
    animation: loadingbar 1250ms linear infinite;
  }

  @media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {
    #SupportWidget .controls .query-field .reset-support-query {
      top: 7px;
    }
    #SupportWidget .controls .query-field input[type='text']::-ms-clear {
      display: none;
    }
  }

  @keyframes loadingbar {
    0% {
      opacity: 0;
    }
    50% {
      opacity: 1;
    }
    100% {
      opacity: 0;
    }
  }
`;

const Toggle = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  background: #ffffff;
  border-left: 1px solid #e4e4e4;
  height: 100%;
  width: 3.5rem;
  cursor: pointer;

  :hover {
    transition: background 300ms;
    background: #57a8e6;
  }

  :hover svg path {
    fill: #ffffff;
  }
`;

const OpenIcon = styled.svg`
  width: 1rem;
  height: 1rem;
  display: block;

  path {
    fill: #4694ce;
  }
`;

const CloseIcon = styled.svg`
  width: 1rem;
  height: 1rem;
  display: none;
`;

export class SupportMenu extends Component {
  componentDidMount() {
    // Is this still required, and should it be done here?
    const dpackScript = document.createElement('script');
    dpackScript.innerText = 'var Dpack = {};';
    document.body.appendChild(dpackScript);

    // Load compiled external support-menu (in public folder)
    const script = document.createElement('script');
    script.src = './support-menu.js';
    document.body.appendChild(script);
  }
  render() {
    return (
      <>
        {/* These need to be props as they change based on the page */}
        <input type="hidden" id="current_dir_viewed" value="dashboard" />
        <input type="hidden" id="current_page_viewed" value="index" />

        <BaseStyles id="widgetWrapper" />

        <div className="support-toggle">
          <Toggle>
            <span>
              <OpenIcon viewBox="0 0 11.99 22.01">
                <path d="M1.21 4.07a1 1 0 0 0 .94.55 1.1 1.1 0 0 0 .56-.16l.66-.36a5.25 5.25 0 0 1 .9-.36 4.45 4.45 0 0 1 1.3-.16 2.3 2.3 0 0 1 1.6.53 1.81 1.81 0 0 1 .58 1.39 2.53 2.53 0 0 1-.31 1.28 4.1 4.1 0 0 1-.78 1 9.21 9.21 0 0 1-1 .81 12 12 0 0 0-1 .78 4 4 0 0 0-.78.9 2.08 2.08 0 0 0-.31 1.14v.36l.32 2.38H7l.41-2.07a1.57 1.57 0 0 1 .46-.83 9 9 0 0 1 .88-.75l1.08-.82a6 6 0 0 0 1-1 5.34 5.34 0 0 0 .79-1.42 5.51 5.51 0 0 0 .31-2 5.36 5.36 0 0 0-.42-2.15 4.64 4.64 0 0 0-1.2-1.66A5.41 5.41 0 0 0 8.48.36 7.89 7.89 0 0 0 6 0a9.33 9.33 0 0 0-1.85.17 8.61 8.61 0 0 0-1.59.47 9.28 9.28 0 0 0-1.38.7A10.31 10.31 0 0 0 0 2.2zm1.7 16.41a2.46 2.46 0 0 0 1.36 1.34 2.71 2.71 0 0 0 1 .19 2.67 2.67 0 0 0 1-.19 2.58 2.58 0 0 0 .83-.53 2.43 2.43 0 0 0 .55-.81 2.52 2.52 0 0 0 .2-1 2.45 2.45 0 0 0-.75-1.79 2.69 2.69 0 0 0-.83-.54 2.58 2.58 0 0 0-1-.2 2.6 2.6 0 0 0-1.85.74 2.51 2.51 0 0 0-.55.8 2.47 2.47 0 0 0-.2 1 2.52 2.52 0 0 0 .24.98z" />
              </OpenIcon>
            </span>

            <span>
              <CloseIcon viewBox="0 0 20 20">
                <path d="M20 2.73L17.27 0 10 7.27 2.73 0 0 2.73 7.27 10 0 17.27 2.73 20 10 12.73 17.27 20 20 17.27 12.73 10z" />
              </CloseIcon>
            </span>
          </Toggle>
        </div>
      </>
    );
  }
}

export default SupportMenu;
